import { FontSizeSwitcherPlugin } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/FontSizeSwitcherPlugin';
import { FontSizeModeEnum } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/types';
import { DolEditor } from '@doltech/ui/lib/figma/DolEditor/DolEditor';
import { ReadOnlyPlugin } from '@doltech/ui/lib/figma/DolEditor/handlers/read-only/ReadOnlyPlugin';
import { SlateListPlugin } from '@doltech/ui/lib/figma/DolEditor/marks/list';
import { BoldPlugin } from '@doltech/ui/lib/slatePlugins/marks/bold/BoldPlugin';
import { withInlineVoid } from '@doltech/ui/lib/slatePlugins/plugins/inline-void/withInlineVoid';
import * as React from 'react';
import styled from 'styled-components';

interface MobileEditorProps {
  key: string;
  value: any;
  hasPadding?: boolean;
}

const DolEditorWrapper = styled(DolEditor)`
  user-select: none;
  pointer-events: none;
`;
export const MobileEditor = (props: MobileEditorProps) => {
  const { key, value, hasPadding = true } = props;
  const plugins = React.useMemo(
    () => [ReadOnlyPlugin(), BoldPlugin(), FontSizeSwitcherPlugin(FontSizeModeEnum.DEFAULT)],
    []
  );

  const withPlugins = React.useMemo(
    () => [SlateListPlugin.withPlugin(), withInlineVoid({ plugins })],
    [plugins]
  );

  return (
    <DolEditorWrapper
      key={key}
      style={{ paddingBottom: hasPadding ? 100 : 0 }}
      initialValue={value}
      plugins={plugins}
      editorChains={withPlugins}
    />
  );
};
